import { CommonAlbumsManager } from './common_albums_manager';
import { 
  IAlbumDataManager, 
  IMoveCopySingleAssetParams, 
  IMoveCopyMultiAssetsParams, 
  IUpdateAlbumDateParms, 
  IUpdateBulkAGAlbumParams, 
  IUpdateBulkUAAlbumParams, 
  IAlbumClusterConfig, 
  IAlbumCollectionListConfig,
  IAlbumCaptionSortJumptoMonthConfig,
  IAlbumCaptionLetterSpecificClusterConfig} from "./ialbum_data_manager";
import { AjaxHelper } from "../../http/ajax_helper";
//import * as $ from "jquery";
import { ITranslator } from "../translators/itranslator";
import { IClientConfig } from "../data_manager/data_manager_factory";
import {
  IOwnedAlbumPhotosParams,
  IRearrageUpdateParams,
  IUpdatingTagParams
} from "./ialbum_data_manager";
import { IDeleteOwnedAlbumParams } from "./ialbum_data_manager";
import { Util } from "../../common_utils/util";
import { AlbumClusterHelper } from "./album_cluster_helper";
/**
 * UAAlbumManager is a class used for all operations related to collection
 *  and single collection as well. 
 * @export
 * @class UAAlbumManager
 * @implements {IAlbumDataManager}
 */
export class UAAlbumManager extends CommonAlbumsManager implements IAlbumDataManager {
  private uaTranslator : ITranslator;
  private discoveryEndPoints: any;
  clusterHelper: AlbumClusterHelper;

  /**
   *Creates an instance of UAAlbumManager and also create an
   *instance of translator if required.
   * @param {IClientConfig} config
   * @memberof UAAlbumManager
   */
  constructor(config: IClientConfig) {
    super();
    this.uaTranslator = Util.getTranslatorObj(config);
    this.discoveryEndPoints = config.discoveryEndPoints;
    this.clusterHelper  = new AlbumClusterHelper();
  }

  /**
   * Method to get albums metadata and first page response .
   * @param {IAlbumClusterConfig} clusterConfig
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getAlbumsClusterMetaData(clusterConfig: IAlbumClusterConfig): Promise<any> {
    clusterConfig = this.clusterHelper.clusterConfig = $.extend(true, this.clusterHelper.clusterConfig, clusterConfig);
    let sortQuery = "";
    if(clusterConfig.sortCriteria){
      sortQuery+= `&searchCriteria=${clusterConfig.sortCriteria}`
    }
    if(clusterConfig.sortOrder){
      sortQuery+= `&sortOrder=${clusterConfig.sortOrder}`
    }
    const clusterMetaQuerySring = `skip=0&limit=0&minCollection=0&timezoneOffset=${clusterConfig.timezoneOffset}${sortQuery}`;
    const clusterMetaUrl = "collection/monthIndex?" + clusterMetaQuerySring;
    const metaPromise =  AjaxHelper.triggerApi({
      requestConfig: {
        url : this.discoveryEndPoints.pictService + clusterMetaUrl,
        type: "GET"
      }
    });
    let projection = "&projection=createDate,assetType,files,faces,ownerAccountId,parentCollectionReferences,assetIdList,userTags,firstAssetId,updateDate,systemTags"
    const clustersQuerySring = `skip=${clusterConfig.skip}&limit=${clusterConfig.limit}&minCollection=1000&timezoneOffset=${clusterConfig.timezoneOffset}${sortQuery}${projection}`;
    const clustersUrl = "collection/monthIndex?" + clustersQuerySring;
    const firstpageResPromise =  AjaxHelper.triggerApi({
      requestConfig: {
        url: this.discoveryEndPoints.pictService + clustersUrl,
        type: "GET"
      }
    });
    let promise = Promise.all([metaPromise, firstpageResPromise]).then(values => { 
      let data = [values[0].data, values[1].data];
      return this.uaTranslator.prepareAlbumPagesData(this.clusterHelper, data)
    });
    return promise;
  }

  /**
   * Method to get page specific albums based on page url .
   * @param {string} pageUrl
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getAlbumClusters(pageUrl: string): Promise<any> {
    const url = "collection/monthIndex?" + pageUrl;
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "GET",
    };
    const promise =  AjaxHelper.triggerApi(
      {requestConfig: config}, this.uaTranslator.translateAlbumClusters.bind(this.uaTranslator)
    )
    return promise;
  }
 
  /**
   * Method used to return the translator object if present or
   * will return undefined if not present   
   * @returns {*}
   * @memberof UAAlbumManager
   */
  getTranslatorObj(): any{
    return this.uaTranslator;
  }

   /**
   * Method to get the info such as caption, desc ectc of an individual album.
   * @param {string} albumId
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getOwnedAlbumInfo(albumId: string): Promise<any> {
    const url = "collection/" + albumId;
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "GET",
    };

    let promise = AjaxHelper.triggerApi({ requestConfig: config }, this.uaTranslator.translateAlbum.bind(this.uaTranslator));
    
    return promise;
  }
 
  /**
   * Method used to load the favorites album,
   * which returns the same response as of owned albums photos.   
   */
  getFavoriteAlbumInfo(): Promise<any> {
    const url = "collection/favorite";
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "GET",
    };

    let promise = AjaxHelper.triggerApi({ requestConfig: config }, this.uaTranslator.translateAlbum.bind(this.uaTranslator));
    
    return promise;
  }
  /**
   * Method to delete a particular album from the albums list     
   * @param {IDeleteOwnedAlbumParams} queryParamsObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  deleteAlbum(queryParamsObj: IDeleteOwnedAlbumParams): Promise<any> {
    const url = "collection/" + queryParamsObj.albumId +
      "?" + Util.prepareParamString(queryParamsObj, ["albumId"]);
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "DELETE",
    };

    let promise = AjaxHelper.triggerApi({ requestConfig: config });    
    return promise;
  }
  
/**
 *Method to update albums date, caption and create date
 *
 * @param {IUpdateBulkAGAlbumParams} data
 * @returns {Promise<any>}
 * @memberof UAAlbumManager
 */
updateAlbumByBulkCall(data: IUpdateBulkAGAlbumParams): Promise<any> {
    const url = 'collection/bulk';
    const tranlatedPayload: Array<IUpdateBulkUAAlbumParams> = this.uaTranslator.translateAlbumBulkAPIPayLoad(data);
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "PUT",
      data: JSON.stringify(tranlatedPayload),
    }
    const promise = AjaxHelper.triggerApi({requestConfig:  config }, this.uaTranslator.translateAssetBulkApiUAResponse.bind(this.uaTranslator));

    return promise;

  }


  /**
   *  move single asset api
   * @param params 
   */
  moveSingleAssetToExistingAlbum(params:IMoveCopySingleAssetParams): Promise<any> {
    const url = 'collection/move/' + params.sourceAlbumId + '/' + params.selectedDestAlbumId + '/' + params.sourceAssetId;
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "PUT",
    }
    let promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  }

  /**
   * copy or move single asset to existing album
   * @param params 
   */
  copyOrMoveSingleAssetToExistingAlbum(params:IMoveCopySingleAssetParams): Promise<any> {
    let url = 'collection/' + params.selectedDestAlbumId + '/copy/' + params.sourceAssetId;
    let uriTemplate = "collection/{selectedDestAlbumId}/copy/{sourceAssetId}"
    if (params.movePhotos) {
      url = 'collection/' + params.sourceAlbumId + '/move/' + params.selectedDestAlbumId + '/' + params.sourceAssetId;
      uriTemplate = "collection/{sourceAlbumId}/move/{selectedDestAlbumId}/{sourceAssetId}"
    }
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "PUT",
    }
    let promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  }

  /**
   * move or copy multiple assets to existing or new album
   * @param isMovePhotos
   * @param data 
   */
  moveOrCopyToAlbum(params:IMoveCopyMultiAssetsParams): Promise<any> {
    let url = 'collection/copy';
    if (params.movePhotos) {
      url = 'collection/move';
    }
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "POST",
      data: JSON.stringify(params.data),
    }
    let promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  } 
  
  /**
   * Method to rearrange the assets in an album.   
   * @param {IRearrageUpdateParams} queryParamsObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  reArrangeAlbum(queryParamsObj: IRearrageUpdateParams): Promise<any> {
    //https://assets.sf-qa.com/pict/v2/collection/11043418235070/rearrange
    const url = "collection/" + queryParamsObj.albumId + "/rearrange";
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "POST",
      data: queryParamsObj.payload,
    }
    let promise = AjaxHelper.triggerApi({ requestConfig: config }, this.uaTranslator.translateAlbum.bind(this.uaTranslator));    
    return promise;
  }
  
  /**
   * Method to save the sort order of an album after sorting.   
   * @param {IUpdatingTagParams} params
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  updateAlbumTag(params: IUpdatingTagParams): Promise<any>{
    const url = "collection/" + params.albumId + "/addTags"
    //https://assets.sf-qa.com/pict/v2/collection/11043671249060/addTags
    let config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "POST",
      data: params.payload,
    }
    let promise = AjaxHelper.triggerApi({ requestConfig: config }, this.uaTranslator.translateAlbum.bind(this.uaTranslator));    
    return promise;
  }
/**
 * Method to update album create date, description and caption
 * @param {IUpdateAlbumDateParms} params
 * @returns {Promise<any>}
 * @memberof UAAlbumManager
 */
updateAlbumDate(params: IUpdateAlbumDateParms): Promise<any>{    
    //https://assets.sf-qa.com/pict/v2/collection/11043671248060/createDateMillis/1576261800000

    const url = "collection/" + params.albumId + "/createDateMillis/" + params.createDate
    const config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "POST",
    }
    let promise = AjaxHelper.triggerApi({ requestConfig: config }, this.uaTranslator.translateOwnedAlbum.bind(this.uaTranslator));    
    return promise;
  }
    
  /**
   * Method to get the assets of a single album. 
   * @param {IOwnedAlbumPhotosParams} paramObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getOwnedAlbumPhotos(paramObj: IOwnedAlbumPhotosParams): Promise<any> {
    const url = 'collection/' + paramObj.albumId + '/assets?' +
       Util.prepareParamString(paramObj, ['albumId']);
    const config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "GET",
    }
    let promise = AjaxHelper.triggerApi(
        { requestConfig: config }, 
        this.uaTranslator.translateOwnedAlbumPhotos.bind(this.uaTranslator,paramObj.sortCriteria) //passing sortCriteria as a parameter to uaTranslator.
      );
    
    return promise;
  }

  /**
   * Method to get the shared token by album id.   
   * @param {string} payload
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getShareTokenForAlbum(payload: string): Promise<any> {
    return super.getShareTokenForAlbum(this.discoveryEndPoints.pictService, payload);
  }

  /**
    * Method to create a new album with the added assets.   
    * @param {string} payload
    * @returns {Promise<any>}
    * @memberof UAAlbumManager
    */
  createAlbum(payload: string): Promise<any> {
    return super.createAlbum(this.discoveryEndPoints.pictService, payload);
  }

  /**
   * Method to get all the albums. 
   * @param {IOwnedAlbumPhotosParams} paramObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getCollectionList(paramObj: IAlbumCollectionListConfig): Promise<any> {
    const url = "collection/list?sortOrder=descending&collectionShown="+paramObj.collectionType+"&skip=" + paramObj.skip + "&limit=" + paramObj.limit + "&projection=ownerAccountId,userTags,systemTags";
    const config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "GET",
    };
    const promise = AjaxHelper.triggerApi({ requestConfig: config });
    return promise;
  }

  /**
   *  Gets all captions with mininum collection list of 10<dynamic value> and returns 
   * {
   *   collectionListRes: data<full response of xhr request>,
   *   jumpToModuleData: jumpToModuleData {Z-Q: Array(2)} //objects of stringsSets with alphabets related to stringsSets
   * }
   * @param {IOwnedAlbumPhotosParams} paramObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getAllCaptionMinCollectionList(paramObj: IAlbumCaptionSortJumptoMonthConfig): Promise<any> {
    const url = "collection/captionIndex?sortCriteria=caption&skip=0&limit=0&sortOrder="+paramObj.sortOrder+"&minCollection="+paramObj.minCollection;
    const config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "GET",
    };
    const bindedFunc = this.uaTranslator.translateAllCaptionMinCollectionListResponse.bind({sortOrder :paramObj.sortOrder,uaTranslator: this.uaTranslator})
    const promise = AjaxHelper.triggerApi({ requestConfig: config },bindedFunc);
    return promise;
  }

  /**
   *  Gets captions with letter specific collection list in ascending/descending orders
   * @param {IOwnedAlbumPhotosParams} paramObj
   * @returns {Promise<any>}
   * @memberof UAAlbumManager
   */
  getCaptionLetterSpecificCollectionList(paramObj: IAlbumCaptionLetterSpecificClusterConfig): Promise<any> {
    const url = "collection/captionIndex/cluster/"+paramObj.captionAlphabetName+"?sortCriteria=caption&skip="+paramObj.skip+"&limit="+paramObj.limit+"&sortOrder="+paramObj.sortOrder+"&minCollection="+paramObj.minCollection;
    const config = {
      url: this.discoveryEndPoints.pictService + url,
      type: "GET",
    };
    const promise = AjaxHelper.triggerApi({ requestConfig: config }, this.uaTranslator.translateIndividualAlphabetCaption.bind(this.uaTranslator));
    return promise;
  }

}
